import axios from 'axios';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

export type DeleteUserParams = {
    sid: string;
    userId: string;
    systemType: string;
};

export function useDeleteUser(options?: UseMutationOptions<unknown, Error, DeleteUserParams>) {
    return useMutation<unknown, Error, DeleteUserParams>({
        mutationFn: async params => {
            const response = await axios.delete('/v1/f1/user', { params });
            return response.data;
        },
        ...options
    });
}
